import React, { Fragment } from "react";
import ButtonPrimary from "@/shared/Button/ButtonPrimary";
import ButtonThird from "@/shared/Button/ButtonThird";
import Checkbox from "@/shared/Checkbox/Checkbox";
import convertNumbThousand from "@/utils/convertNumbThousand";
import Slider from "rc-slider";
import { useAppContext } from "@/context/AppContext";
import { Popover, Transition } from "@headlessui/react";
import { Dialog } from "@/components/Dialog/Dialog";

export interface TabFiltersProps {
  cities?: string[];
  adBoardTypes?: string[];
  specifications?: string[];
  rangePrices?: [number, number];
  isOnSale?: boolean;
  guestsAndBags?: {
    passengers: number;
    bags: number;
  };
  onChange: (filters: {
    cities?: string[];
    adBoardTypes?: string[];
    specifications?: string[];
    rangePrices?: [number, number];
    isOnSale?: boolean;
    guestsAndBags?: {
      passengers: number;
      bags: number;
    };
  }) => void;
  }

const TabFilters = ({
  cities = [],
  adBoardTypes = [],
  rangePrices = [0, 25000],
  // isOnSale = false,
  // guestsAndBags = { passengers: 1, bags: 1 },
  onChange,
}: TabFiltersProps) => {
  const {adBoardTypes:defaultAdBoardTypes,cities:defaultCities} = useAppContext()

  const renderXClear = (callback?:()=>void) => {
    return (
      <span className="w-4 h-4 rounded-full bg-primary-500 text-white flex items-center justify-center ml-3 cursor-pointer" onClick={(e)=>{
        e.stopPropagation()
        callback?.();
      }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    );
  };

  function renderLocationDialog() {
    return (
      <div className="relative flex flex-col px-5 py-6 space-y-5">
        <span className="font-medium">Location</span>
        {defaultCities.filter(item=>item.city!='All').map((city) => {
          const item={
            name:city.city
          }
          return (
            <div key={item.name} className="">
              <Checkbox
                name={item.name}
                label={item.name}
                // subLabel={item.description}
                checked={cities.includes(item.name)}
                onChange={(checked) => {
                  const newCarType = checked 
                    ? [...cities, item.name]
                    : cities.filter(type => type !== item.name);
                  onChange({ cities: newCarType });
                }}
              />
            </div>
          )})}
      </div>
    )
  }

  const renderTabsTypeOfCars = () => {
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-neutral-300 dark:border-neutral-700 hover:border-neutral-400 dark:hover:border-neutral-500 focus:outline-none ${
                (open||cities.length) ? "!border-primary-500 " : ""
              }`}
            >
              <span>Location {(cities.length?"("+cities.length+")":"")}</span>
              {/* <i className="las la-angle-down ml-2"></i> */}
              {cities.length ? renderXClear(function(){
                onChange({ cities: [] });
              }) : <i className="las la-angle-down ml-2"></i>}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-md">
                <div className="overflow-hidden rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700">
                  {renderLocationDialog()}
                  <div className="p-5 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between">
                    <ButtonThird onClick={()=>{
                      onChange({ cities: [] });
                      close();
                    }} sizeClass="px-4 py-2 sm:px-5">
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={close}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Close
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  const renderAdboardTypes = () => {
    const types = defaultAdBoardTypes.map(item=>{
      return {name: item.name}
    })
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-neutral-300 dark:border-neutral-700 hover:border-neutral-400 dark:hover:border-neutral-500 focus:outline-none ${
                (open||adBoardTypes.length) ? "!border-primary-500 " : ""
              }`}
            >
              <span>Adboard type</span>
              {adBoardTypes.length ? renderXClear(function(){
                onChange({ adBoardTypes: [] });
              }) : <i className="las la-angle-down ml-2"></i>}
              
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-md">
                <div className="overflow-hidden rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700">
                  <div className="relative flex flex-col px-5 py-6 space-y-5">
                    {types.map((item) => {
                      return (
                        <div key={item.name} className="">
                          <Checkbox
                            name={item.name}
                            label={item.name}
                            // subLabel={item.description}
                            checked={adBoardTypes.includes(item.name)}
                            onChange={(checked) => {
                              const newCarType = checked 
                                ? [...adBoardTypes, item.name]
                                : adBoardTypes.filter(type => type !== item.name);
                              onChange({ adBoardTypes: newCarType });
                            }}
                          />
                        </div>
                      )})}
                  </div>
                  <div className="p-5 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between">
                    <ButtonThird onClick={()=>{
                      onChange({ adBoardTypes: [] });
                      close();
                    }} sizeClass="px-4 py-2 sm:px-5">
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={close}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Close
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  const renderRangePriceDialog = () => {
    return (
      <div className="relative flex flex-col px-5 py-6 space-y-8">
        <div className="space-y-5">
          <span className="font-medium">Price per day</span>
          <Slider
            range
            className="text-red-400"
            min={0}
            max={25000}
            defaultValue={[rangePrices[0], rangePrices[1]]}
            allowCross={false}
            onChange={(e) => onChange({ rangePrices: e as [number, number] })}
          />
        </div>

        <div className="flex justify-between space-x-5">
          <div>
            <label
              htmlFor="minPrice"
              className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
            >
            Min price
            </label>
            <div className="mt-1 relative rounded-md">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-neutral-500 sm:text-sm">
                  ₹
                </span>
              </div>
              <input
                type="text"
                name="minPrice"
                disabled
                id="minPrice"
                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-3 sm:text-sm border-neutral-200 rounded-full text-neutral-900"
                value={rangePrices[0]}
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="maxPrice"
              className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
            >
            Max price
            </label>
            <div className="mt-1 relative rounded-md">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-neutral-500 sm:text-sm">
              ₹
                </span>
              </div>
              <input
                type="text"
                disabled
                name="maxPrice"
                id="maxPrice"
                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-3 sm:text-sm border-neutral-200 rounded-full text-neutral-900"
                value={rangePrices[1]}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderTabsPriceRage = () => {
    const isRangeSet = rangePrices[0] !== 0 || rangePrices[1] !== 25000;
    return (
      <Popover className="relative">
        {({ close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-neutral-300 dark:border-neutral-700 hover:border-neutral-400 dark:hover:border-neutral-500 focus:outline-none
                ${(isRangeSet)? " !border-primary-500 " : ""}
                `}
            >
              <span>
                {`₹${convertNumbThousand(
                  rangePrices[0]
                )} - ₹${convertNumbThousand(rangePrices[1])}`}{" "}
              </span>
              {isRangeSet? renderXClear(function(){
                onChange({ rangePrices: [0, 25000] });
              }) : <i className="las la-angle-down ml-2"></i> }
              {/* {renderXClear()} */}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 ">
                <div className="overflow-hidden rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700">
                  {renderRangePriceDialog()}
                  <div className="p-5 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between">
                    <ButtonThird onClick={()=>{
                      onChange({ rangePrices: [0, 25000] });
                      close()
                    }} sizeClass="px-4 py-2 sm:px-5">
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={close}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Close
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  const renderTabMoreFilter = () => {
    return (

      <div>
        <Dialog header="Filters">
          <Dialog.Trigger>
            <div
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-neutral-300 dark:border-neutral-700 hover:border-neutral-400 dark:hover:border-neutral-500 cursor-pointer`}
              // onClick={openModalMoreFilter}
            >
              <span>All filters</span>
              {/* {renderXClear()} */}
            </div>
          </Dialog.Trigger>
          <Dialog.Body>
            {({closeDialog})=>{
              return (
                <div className="text-center pb-8 ">
                  <div className="text-left align-middle">
                    {/* //TODO */}
                    <div className="flex gap-2 h-full  flex-col">
                      <div className="box">
                        {renderLocationDialog()}
                      </div>
                      <div className="box">
                        {renderRangePriceDialog()}
                      </div>
                    </div>
                    <div className="mt-4">
                      <ButtonPrimary
                        onClick={()=>closeDialog()}
                        sizeClass="px-4 py-2 sm:px-5"
                      >
                      Close
                      </ButtonPrimary>
                    </div>
                  </div>
              
                </div>
              )}}
          </Dialog.Body>
        </Dialog>
        
      </div>
    );
  };

  return (
    <div className="flex lg:space-x-4 w-full">
      <div className="hidden lg:flex space-x-4 w-full">
        <div className="flex justify-between w-full">
          <div className="flex gap-2 flex-1">
            {renderTabsTypeOfCars()}
            {renderAdboardTypes()}
            {renderTabsPriceRage()}
          </div>
          {/* {renderTabsGuestsAndBags()} */}
          {renderTabMoreFilter()}
        </div>
      </div>
      <div className="flex lg:hidden space-x-4">
        {renderTabsTypeOfCars()}
        {/* {renderAdboardTypes()} */}
        {/* {renderTabsPriceRage()} */}
        {/* {renderTabsGuestsAndBags()} */}
        {renderTabMoreFilter()}
      </div>
    </div>
  );
};

export default TabFilters;
